import applyMiddleware from '../../utils/route/applyMiddleware';
import requireRole from '../../utils/route/requireRole';
import Roles from '../../constants/Roles';

const bankApp = {
  name: 'bank-info',
  path: 'bank-info',
  onEnter: applyMiddleware(requireRole(Roles.BANK_MANAGER)),
  async getComponent() {
    const {BankInfoMain} = await import('./BankRoutes');

    return BankInfoMain;
  },

  async getChildRoutes() {
    const {BankRoutes} = await import('./BankRoutes');

    return BankRoutes;
  }
};

export default bankApp;



// WEBPACK FOOTER //
// ./src/apps/Bank/index.js